import React from 'react';
//import {Card} from 'antd';
class Statistics extends React.Component {
  render() {
    return <div>
    </div>
  }
}
export default Statistics



// WEBPACK FOOTER //
// ./src/pages/Statistics.js